import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface MessageListItem {
  id: number;
  at: string;
  message: string;
  sender: string;
  candidate_id: number;
  subscription_id: number;
  candidate_name?: string | null;
}

export interface PaginatedMessagesResponse {
  items: MessageListItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export async function listMessages(
  navigate: NavigateFunction,
  params?: { page?: number; size?: number; candidate_id?: number; sender?: string }
) {
  const q = new URLSearchParams();
  q.set("page", String(params?.page ?? 1));
  q.set("size", String(params?.size ?? 50));
  if (params?.candidate_id) q.set("candidate_id", String(params.candidate_id));
  if (params?.sender) q.set("sender", params.sender);
  const url = `${API_URL}/messages?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des messages");
  return res.json() as Promise<PaginatedMessagesResponse>;
}
